import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { SubdomainRouter } from "@/components/SubdomainRouter";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import CreatePassword from "@/pages/CreatePassword";
import SetupPassword from "@/pages/SetupPassword";
import ResetPassword from "@/pages/ResetPassword";

import StudentDashboard from "@/pages/student/Dashboard";
import StudentCourse from "@/pages/student/Course";
import StudentRecordings from "@/pages/student/Recordings";
import StudentModules from "@/pages/student/Modules";
import StudentModuleDetail from "@/pages/student/ModuleDetail";
import StudentNotes from "@/pages/student/Notes";
import StudentProgress from "@/pages/student/Progress";
import StudentAnnouncements from "@/pages/student/Announcements";
import StudentEvents from "@/pages/student/Events";
import StudentEventDetail from "@/pages/student/EventDetail";
import StudentProfile from "@/pages/student/Profile";

import AdminDashboard from "@/pages/admin/Dashboard";
import AdminStudents from "@/pages/admin/Students";
import AdminBatches from "@/pages/admin/Batches";
import AdminRecordings from "@/pages/admin/Recordings";
import AdminModules from "@/pages/admin/Modules";
import AdminNotes from "@/pages/admin/Notes";
import AdminEvents from "@/pages/admin/Events";
import AdminAnnouncements from "@/pages/admin/Announcements";
import AdminReports from "@/pages/admin/Reports";
import AdminSecurity from "@/pages/admin/Security";
import AdminContent from "@/pages/admin/Content";
import AdminPreviewVideos from "@/pages/admin/PreviewVideos";
import AdminSettings from "@/pages/admin/Settings";

import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <SubdomainRouter />
            <Routes>
            {/* Public */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/create-password" element={<CreatePassword />} />
            <Route path="/setup-account" element={<CreatePassword />} />
            <Route path="/setup-password" element={<SetupPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Student */}
            <Route path="/student/dashboard" element={<ProtectedRoute role="student"><StudentDashboard /></ProtectedRoute>} />
            <Route path="/student/course" element={<ProtectedRoute role="student"><StudentCourse /></ProtectedRoute>} />
            <Route path="/student/recordings" element={<ProtectedRoute role="student"><StudentRecordings /></ProtectedRoute>} />
            <Route path="/student/modules" element={<ProtectedRoute role="student"><StudentModules /></ProtectedRoute>} />
            <Route path="/student/module/:id" element={<ProtectedRoute role="student"><StudentModuleDetail /></ProtectedRoute>} />
            <Route path="/student/notes" element={<ProtectedRoute role="student"><StudentNotes /></ProtectedRoute>} />
            <Route path="/student/progress" element={<ProtectedRoute role="student"><StudentProgress /></ProtectedRoute>} />
            <Route path="/student/announcements" element={<ProtectedRoute role="student"><StudentAnnouncements /></ProtectedRoute>} />
            <Route path="/student/events" element={<ProtectedRoute role="student"><StudentEvents /></ProtectedRoute>} />
            <Route path="/student/events/:id" element={<ProtectedRoute role="student"><StudentEventDetail /></ProtectedRoute>} />
            <Route path="/student/profile" element={<ProtectedRoute role="student"><StudentProfile /></ProtectedRoute>} />
            <Route path="/student" element={<Navigate to="/student/dashboard" replace />} />

            {/* Admin */}
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/students" element={<ProtectedRoute role="admin"><AdminStudents /></ProtectedRoute>} />
            <Route path="/admin/batches" element={<ProtectedRoute role="admin"><AdminBatches /></ProtectedRoute>} />
            <Route path="/admin/recordings" element={<ProtectedRoute role="admin"><AdminRecordings /></ProtectedRoute>} />
            <Route path="/admin/modules" element={<ProtectedRoute role="admin"><AdminModules /></ProtectedRoute>} />
            <Route path="/admin/notes" element={<ProtectedRoute role="admin"><AdminNotes /></ProtectedRoute>} />
            <Route path="/admin/events" element={<ProtectedRoute role="admin"><AdminEvents /></ProtectedRoute>} />
            <Route path="/admin/announcements" element={<ProtectedRoute role="admin"><AdminAnnouncements /></ProtectedRoute>} />
            <Route path="/admin/content" element={<ProtectedRoute role="admin"><AdminContent /></ProtectedRoute>} />
            <Route path="/admin/preview-videos" element={<ProtectedRoute role="admin"><AdminPreviewVideos /></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute role="admin"><AdminReports /></ProtectedRoute>} />
            <Route path="/admin/security" element={<ProtectedRoute role="admin"><AdminSecurity /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute role="admin"><AdminSettings /></ProtectedRoute>} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
